import { Result } from "../../models/general";
import { UserVariablePayInput, UserVariablePayView, CompanyVariablePayTypeInput, CompanyVariablePayTypeView } from "../../models/payroll";
import request from "../../utils/request";

export async function getCompanyVariablePayTypes() {
    const response = await request.get<Result<CompanyVariablePayTypeView[]>>("VariablePay/GetCompanyVariablePayTypes");
    return response.data;
}

export async function addCompanyVariablePayType(input: CompanyVariablePayTypeInput) {
    const response = await request.post<Result<CompanyVariablePayTypeView>>("VariablePay/AddCompanyVariablePayType", input);
    return response.data;
}

export async function editCompanyVariablePayType(variablePayTypeId: number, input: CompanyVariablePayTypeInput) {
    const response = await request.post<Result<CompanyVariablePayTypeView>>(`VariablePay/EditCompanyVariablePayType/${variablePayTypeId}`, input);
    return response.data;
}

export async function deleteCompanyVariablePayType(variablePayTypeId: number) {
    const response = await request.post<Result<CompanyVariablePayTypeView[]>>(`VariablePay/DeleteCompanyVariablePayType/${variablePayTypeId}`);
    return response.data;
}

export async function getUserVariablePaysPerMonth(userId: string, date: string, currencyId: number) {
    const response = await request.get<Result<UserVariablePayView[]>>("VariablePay/GetUserVariablePaysPerMonth", {
        params: { userId, date, currencyId },
    });
    return response.data;
}

export async function addUserVariablePay(input: UserVariablePayInput) {
    const response = await request.post<Result<UserVariablePayView>>("VariablePay/AddUserVariablePay", input);
    return response.data;
}

export async function updateUserVariablePay(input: UserVariablePayInput) {
    const response = await request.post<Result<UserVariablePayView>>("VariablePay/UpdateUserVariablePay", input);
    return response.data;
}

export async function deleteUserVariablePay(id: number) {
    const response = await request.post<Result<UserVariablePayView>>(`VariablePay/DeleteUserVariablePay/${id}`);
    return response.data;
}